import { createRelayResource } from '@townsquare/relay-utils';

import JiraIntegrationLinkQuery, {
	type JiraIntegrationLinkQuery as JiraIntegrationLinkQueryType,
} from '../components/ProjectSidebar/WorkTrackingLinks/JiraIntegrationLink/__generated__/JiraIntegrationLinkQuery.graphql';

export const jiraIntegrationLinkResource = createRelayResource<JiraIntegrationLinkQueryType>({
	getQuery: (routerContext) => {
		return {
			query: JiraIntegrationLinkQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
			},
		};
	},
});
